export default {
      id: "wedo-1-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#wedo-1",
      toString: function () {
        return this.url;
      }
    }